import { HttpClient } from '../httpClient';
import Payrate from '../models/payrate';
import { DataResponse } from '../responses/baseResponse';
import PayrateResponse from '../responses/payateResponse';
import PayrateRequest from '../requests/payrateRequest';

const httpClient = new HttpClient();

export const getPayrateById = async (id: any) => {
  return httpClient.get<DataResponse<Payrate>>({
    url: `/v1/Payrates/ById/${id}`,
    requiresToken: true,
  });
};

export const getPayrates = async (therapistId: number) => {
  return httpClient.get<DataResponse<Payrate[]>>({
    url: `/v1/Payrates/${therapistId}`,
    requiresToken: true,
  });
};

export const getPayratesByDistrictId = async (districtId: number) => {
  return httpClient.get<DataResponse<Payrate[]>>({
    url: `/v1/Payrates/ByDistrict/${districtId}`,
    requiresToken: true,
  });
};

export const getPayratesByTherapist = async (
  disciplineId: number,
  userId: number
) => {
  return httpClient.get<DataResponse<Payrate[]>>({
    url: `/v1/Payrates/ByTherapist/${disciplineId}/${userId}`,
    requiresToken: true,
  });
};

export const createPayrate = async (Payraterequest: PayrateRequest) => {
  return httpClient.post<DataResponse<PayrateRequest>>({
    url: '/v1/admin/Payrates',
    payload: Payraterequest,
    requiresToken: true,
  });
};

export const createPayrateBilling = async (Payraterequest: PayrateRequest) => {
  return httpClient.post<DataResponse<Payrate[]>>({
    url: '/v1/admin/PayRates/payratesBilling',
    payload: Payraterequest,
    requiresToken: true,
  });
};

export const updatePayrate = async (
  PayrateId: number,
  Payraterequest: PayrateRequest
) => {
  return httpClient.put<DataResponse<PayrateRequest>>({
    url: `/v1/admin/Payrates/${PayrateId}`,
    payload: Payraterequest,
    requiresToken: true,
  });
};

export const updatePayrateBilling = async (
  PayrateId: number,
  Payraterequest: PayrateRequest
) => {
  return httpClient.put<DataResponse<Payrate[]>>({
    url: `/v1/admin/Payrates/updatePayrateBilling/${PayrateId}`,
    payload: Payraterequest,
    requiresToken: true,
  });
};

export const deletePayrate = async (PayrateId: number) => {
  return httpClient.post<PayrateResponse>({
    url: `/v1/admin/Payrates/${PayrateId}/Delete`,
    requiresToken: true,
  });
};
